<template>
  <v-badge
    :color="getGoalStatusTypeColor(statusId)"
    :content="status.count || '0'"
    overlap
  >
    <avatar
      :icon="getGoalStatusTypeIcon(statusId)"
      :size="55"
      iconColor="secondarytext"
      borderColor="secondarytext"
      borderStyle="1"
      :iconSize="30"
    >
      <template v-slot:tooltip>
        {{ name }}
      </template>
    </avatar>
  </v-badge>
</template>

<script>
import goalStatusTypes from "@/helpers/mixins/goalStatusTypes";
import { mapGetters } from "vuex";
export default {
  name: "GoalAvatar",
  mixins: [goalStatusTypes],
  props: { status: { type: Object } },
  computed: {
    statusId() {
      return this.status.statusId ?? this.status.id;
    },
    name() {
      return (this.goal_statuses.find(x => x.id == this.statusId) || {}).name;
    },
    ...mapGetters({
      goal_statuses: "lookup/goal_statuses"
    })
  }
};
</script>
